/**
 *
 *  MeetingItem
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip, ListGroupItem } from 'react-bootstrap';
import { pick } from 'lodash-es';
import { useIntl } from 'react-intl';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import Icon from 'components/media/Icon/index.js';
import VideoIcon from 'components/VideoConf/VideoIcon.jsx';
import timeFormat from 'utils/timeFormat.js';
import cx from 'utils/cx.js';
import Parents from '../../../Parents.jsx';
import messages from './messages.js';

function tooltip(slots) {
  const text = slots.map((o) => timeFormat(o, 'LT')).join(', ');
  return (
    <Tooltip placement="right" className="in" id="tooltip-right">
      {text}
    </Tooltip>
  );
}

function MeetingItem(props) {
  const { meeting, onClick } = props;
  const hasVideo = Boolean(meeting.videoMeeting);
  const intl = useIntl();
  const title = hasVideo ? intl.formatMessage(messages.noAssignVideo) : undefined;
  const handleClick = hasVideo ? undefined : onClick;

  function getParticipants() {
    if (meeting.details) {
      return pick(meeting.details, ['student', 'parents']);
    }
    const { student } = meeting;
    if (!student) {
      return {};
    }
    const parents = meeting.parentIds.map((pid) => student.connections[pid]);
    return { student, parents };
  }

  const { student, parents } = getParticipants();
  if (!student) {
    return null;
  }
  return (
    <ListGroupItem className={cx('d-flex justify-content-between', { opaque: hasVideo })} action={Boolean(handleClick)} onClick={handleClick} title={title}>
      <AvatarWithText src={student.avatar} className="text-nowrap">
        {meeting.details.assigned
          ? (
            <OverlayTrigger placement="right" overlay={tooltip(meeting.details.slots)}>
              <div className="text-primary">
                {student.displayName}
                <Icon inline className="ss-checkmark text-success ms-2" />
                <VideoIcon {...meeting.videoMeeting} className="ms-2" />
              </div>
            </OverlayTrigger>
          )
          : student.displayName}
      </AvatarWithText>
      <Parents parents={parents} className="small pt-1 text-end text-muted" />
    </ListGroupItem>
  );
}

MeetingItem.propTypes = {
  meeting: PropTypes.object,
  onClick: PropTypes.func,
};

export default MeetingItem;
